/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/days_in_month.json`.

import type { PromqlFunctionDefinition } from '../../definition_types';

/**
 * Returns the number of days in the month for each of the input timestamps (in UTC). Returned values are from 28 to 31.
 *
 * @example
 * days_in_month()
 */
const definition: PromqlFunctionDefinition = {
  type: 'time',
  name: 'days_in_month',
  signatures: [
    {
      params: [
        {
          name: 'v',
          type: 'instant_vector',
          optional: true,
          description: 'Optional instant vector input. If omitted, evaluation timestamp is used.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
